import { LoadingOverlay } from '@mantine/core'

export const Loading = () => {
  return (
    <LoadingOverlay
      visible
      style={{ position: 'fixed', inset: 0, zIndex: 999999 }}
      loaderProps={{ color: 'primary', size: 'md' }}
    />
  )
}
